import SvgAcneBodySprayGlyph from './svgs/AcneBodySprayGlyph.js';
import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import { useIcon } from '../../shared-components/icon/index.js';

var acneBodySprayGlyph = (props => useIcon(SvgAcneBodySprayGlyph, SvgAcneBodySprayGlyph, props));

export { acneBodySprayGlyph as default };
